import { forwardRef, type SVGProps } from 'react';

export const Edit = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path d="M16.187 3.511a.514.514 0 0 0-.707 0L4.067 14.924a.5.5 0 0 0 0 .707l4.28 4.28a.5.5 0 0 0 .707 0L20.467 8.5a.5.5 0 0 0 0-.707z" />
      <path d="M3 16.71a.5.5 0 0 0-.828.2l-2.14 6.42a.5.5 0 0 0 .12.512.508.508 0 0 0 .512.121l6.42-2.139a.5.5 0 0 0 .2-.829z" />
      <path d="M22.968 1.017a3.613 3.613 0 0 0-4.988 0l-.712.713a.5.5 0 0 0 0 .707l4.279 4.28a.5.5 0 0 0 .707 0L22.968 6a3.53 3.53 0 0 0 0-4.983z" />
    </g>
  </svg>
));
